import { render } from "./Player.vue?vue&type=template&id=3db0970d&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=3db0970d&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/afsmc-website-ilna8d14el/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db0970d"]])

export default __exports__